<template>
  <nav
    class="navbar navbar-default fixed-top"
    style="justify-content: right !important; z-index: 999"
  >
    <div
      class="container"
      :style="isCalendarRoute ? { 'padding-right': '32px' } : { 'padding-right': '7.6%' }"
      style="justify-content: right !important"
    >
      <div class="logo">
        <img
          v-animate-css="'slideInLeft'"
          src="/img/1x/logo1.png"
          alt=""
          class="img-fluid"
          style="width: 132px; position: absolute; top: 14px"
          :style="isCalendarRoute ? { left: '32px' } : { left: '8%' }"
        />
      </div>

      <!-- Título del calendario, junto al logo (movido aquí desde Calendar.vue /
           HotelCalendar.vue). El texto cambia según sea calendario de apartamento u hotel. -->
      <div v-if="isMainCalendar" class="cal-navtitle only-lg">
        <span class="cal-navtitle__bar"></span>
        <div class="cal-navtitle__tx">
          <!-- Mientras se sabe de qué propiedad es el calendario, un hueco del
               tamaño del nombre. Poner «Calendario (Channel Manager)» y
               cambiarlo medio segundo después por el nombre se ve como un
               error, no como una carga. -->
          <template v-if="esperandoNombreDeLaPropiedad">
            <div class="cal-navtitle__hueco"></div>
            <div class="cal-navtitle__s">{{ $t("calendar.title") }}</div>
          </template>
          <template v-else>
            <div class="cal-navtitle__t">{{ calNavTitle }}</div>
            <div class="cal-navtitle__s">{{ calNavSubtitle }}</div>
          </template>
        </div>
      </div>

      <div
        class="pasos lg"
        v-if="$route.name == 'checkinManual'"
        style="
          position: fixed;
          left: 0;
          right: 0;
          margin: auto;
          text-align: center;
          width: 40%;
        "
      >
        <ul
          class="d-flex flex-row"
          style="
            margin: auto;
            text-align: center;
            align-items: center;
            justify-content: center;
          "
        >
          <li
            :class="{ cursor: $store.state.stateProcess == 2 }"
            @click.prevent="menuActive(1)"
            :style="
              $store.state.stateProcess == 1
                ? { 'font-weight': 'bold', color: '#333' }
                : { 'font-weight': 'bold', color: 'rgb(167 167 167)' }
            "
          >
            {{ $t("app.t.text75") }}
          </li>
          <div
            class="line-separator"
            style="
              height: 2px;
              background: rgb(138 138 138);
              width: 60px;
              margin-left: 20px;
              margin-right: 20px;
            "
          ></div>
          <li
            :style="
              $store.state.stateProcess == 2
                ? { 'font-weight': 'bold', color: '#333' }
                : { 'font-weight': 'bold', color: 'rgb(167 167 167)' }
            "
          >
            {{ $t("app.t.text76") }}
          </li>

          <div
            class="line-separator"
            style="
              height: 2px;
              background: rgb(138 138 138);
              width: 60px;
              margin-left: 20px;
              margin-right: 20px;
            "
          ></div>
          <li
            :style="
              $store.state.stateProcess == 3
                ? { 'font-weight': 'bold', color: '#333' }
                : { 'font-weight': 'bold', color: 'rgb(167 167 167)' }
            "
          >
            {{ $t("app.t.text77") }}
          </li>
        </ul>
      </div>

      <button
        v-if="isMainCalendar"
        class="nav-guides-btn"
        type="button"
        :aria-label="$t('miscTailHc.maquetaCreateNav.guidesAria')"
        @click.prevent="openGuides"
      >
        <span class="nav-guides-btn__ico">
          <svg viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="9.3" fill="currentColor" />
            <path d="M10.3 8.85v6.3a.7.7 0 0 0 1.08.59l4.95-3.15a.7.7 0 0 0 0-1.18L11.38 8.26a.7.7 0 0 0-1.08.59Z" fill="#fff" />
          </svg>
        </span>
        <span class="nav-guides-btn__dot"></span>
        <span class="nav-guides-btn__tip">{{ $t("miscTailHc.maquetaCreateNav.guidesTip") }}</span>
      </button>

      <notifications-nav
        v-if="!$isMobile && !isPropietario"
        @eventOpenService="openService"
        @eventActiveModalData="activeModalData"
      />

      <div
        class="equis-cerrar"
        @click="
          $route.name == 'createPropiedad'
            ? Regresar(1)
            : $route.name == 'createServicio'
            ? Regresar(3)
            : $route.name == 'updateServicio'
            ? Regresar(3)
            : $route.name == 'updatePropiedad'
            ? Regresar(1)
            : $route.name == 'checkinManual'
            ? Regresar(1)
            : $route.name == 'checkinPrevie'
            ? Regresar(11)
            : $route.name == 'checkinPrevieLink'
            ? Regresar(1)
            : $route.name == 'firstCreatePropiedad'
            ? Regresar(4)
            : $route.name == 'manageChatBot'
            ? Regresar(12)
            : $route.name == 'ReservationCalendar'
            ? Regresar(14)
            : $route.name == 'hotelReservationCalendar'
            ? Regresar(14)
            : $route.name == 'hourlyCalendar'
            ? Regresar(14)
            : $route.name == 'monthlyCalendar'
            ? Regresar(14)
            : $route.name == 'availabilityPrices'
            ? Regresar(14)
            : Regresar(2)
        "
        style="
          font-size: 25px;
          width: 53px;
          cursor: pointer;
          padding-left: 18px;
          border-left: 1px solid #eee;
        "
      >
        <i class="fal fa-times" style="cursor: pointer"></i>
      </div>
    </div>
  </nav>
</template>
<script>
import NotificationsNav from "@/components/Template/notificationsNav.vue";

export default {
  data() {
    return {
      /* El nombre de la propiedad del calendario mensual. Llega por el root y no
         por el store porque es de UNA pantalla: guardarlo fuera lo dejaría puesto
         al salir de ella. Se limpia al desmontarse el calendario. */
      calPropertyName: "",
    };
  },

  mounted() {
    this.$root.$on("cal-property-name", this.setCalPropertyName);
    console.log("nav component");
    console.log(this.$route.name);

    this.$funtion.Notifications();

    if (
      this.$store.state.userRoot &&
      this.$store.state.userRoot?.servicios &&
      this.$store.state.userRoot?.suscription_id_stripe
    ) {
      this.$store.state.demo = false;
    }
  },

  beforeDestroy() {
    this.$root.$off("cal-property-name", this.setCalPropertyName);
  },

  watch: {
    "$store.state.userRoot"() {
      if (
        this.$store.state.userRoot &&
        this.$store.state.userRoot?.servicios &&
        this.$store.state.userRoot?.suscription_id_stripe
      ) {
        this.$store.state.demo = false;
      }
    },
  },
  
  components: {
    NotificationsNav,
  },
  computed: {
    isPropietario() {
      return this.$store.state.subUser?.sub_role === "propietario";
    },
    // Rutas de calendario: el nav debe alinear logo (izq) e íconos (der) con el
    // contenido del calendario (padding-inline 32px), sin meterlos hacia dentro.
    isCalendarRoute() {
      return [
        "ReservationCalendar",
        "hotelReservationCalendar",
        "hourlyCalendar",
        "availabilityPrices",
        "monthlyCalendar",
      ].includes(this.$route.name);
    },
    // Calendario principal (Channel Manager + Hotelero + Disponibilidad/Tarifas):
    // muestra su título junto al logo.
    isMainCalendar() {
      return [
        "ReservationCalendar",
        "monthlyCalendar",
        "hotelReservationCalendar",
        "hourlyCalendar",
        "availabilityPrices",
      ].includes(this.$route.name);
    },
    // El calendario hotelero usa su propio título; el resto, el del Channel Manager.
    isHotelCalendar() {
      return this.$route.name === "hotelReservationCalendar";
    },
    isAvailabilityPrices() {
      return this.$route.name === "availabilityPrices";
    },
    /* Solo en el mensual, y solo hasta que llegue el nombre: en las demás
       pantallas el título es fijo y un esqueleto ahí sobraría. */
    esperandoNombreDeLaPropiedad() {
      return this.$route.name === "monthlyCalendar" && !this.calPropertyName;
    },

    calNavTitle() {
      if (this.isHotelCalendar) return this.$t("empresa.reservas.p111"); // "Calendario Hotelero"
      if (this.$route.name === "hourlyCalendar") return this.$t("hourlyCalendar.title");
      if (this.isAvailabilityPrices) return this.$t("miscTailHc.maquetaCreateNav.availabilityPricesTitle");
      /* El calendario mensual es de UNA propiedad: su nombre es el título, y el
         rótulo del Channel Manager baja al subtítulo. Así la pantalla no repite
         el nombre en dos sitios y la barra de filtros sube. */
      if (this.$route.name === "monthlyCalendar" && this.calPropertyName) return this.calPropertyName;
      return this.$t("calendar.title");
    },
    calNavSubtitle() {
      if (this.isHotelCalendar) return this.$t("miscTailHc.maquetaCreateNav.hotelCalendarSubtitle");
      if (this.$route.name === "hourlyCalendar") return this.$t("hourlyCalendar.navSubtitle");
      if (this.isAvailabilityPrices) return this.$t("miscTailHc.maquetaCreateNav.availabilityPricesSubtitle");
      if (this.$route.name === "monthlyCalendar" && this.calPropertyName) return this.$t("calendar.title");
      return this.$t("calendar.subtitle");
    },
  },
  methods: {
    setCalPropertyName(nombre) {
      this.calPropertyName = nombre || "";
    },

    // Abre el Centro de guías en video (componente global VideoGuides en App.vue).
    openGuides() {
      this.$root.$emit("open-video-guides");
    },
    activeModalData(id) {
      this.$funtion.modalDatosGeneral(id);
    },
    openService(id) {
      localStorage.setItem("service_id", null);
      window.location.href = "/business/service?service_id=" + id;
    },

    menuActive() {
      if (this.$store.state.stateProcess == 2) {
        this.$store.state.stateProcess = 1;
      }
    },

    logout() {
      this.$store
        .dispatch("destroyToken")
        .then(() => {
          window.location.href = "/";
        })
        .catch(() => {
          toastr.error(this.$t("app.t.text79"));
        });
    },

    Regresar(numer) {
      if (numer == 1) {
        this.$router.push({ name: "Bookings" });
      } else if (numer == 3) {
        // Cerrar el editor de servicio (X): volver y REABRIR el drawer de
        // "Experiencias y servicios" donde estaba el usuario (igual que al guardar).
        try { sessionStorage.setItem("wc_reopen_upselling", "1"); } catch (e) {}
        this.$router.go(-1);
      } else if (numer == 11) {
        this.$router.push({ name: "Reservas" });
      } else if (numer == 14) {
        this.$router.push({ name: "Dashboard" });
      } else if (numer == 12) {
        this.$router.back();
      } else if (numer == 4) {
        if (this.$route.query.from === "listings") {
          // Se abrió desde el gestor de anuncios → volver allí.
          this.$router.push({ name: "ListingManager" });
        } else if (this.$route.query.create_user) {
          this.$router.back();
        } else {
          this.$swal({
            title: this.$t("app.t.text80"),
            text: this.$t("app.t.text81"),
            icon: "warning",
            showCancelButton: true,
            cancelButtonColor: "gray",
            confirmButtonColor: "#c00202",
            confirmButtonText: this.$t("app.t.text82"),
            cancelButtonText: this.$t("app.t.text83"),
          }).then((result) => {
            if (result.isConfirmed) {
              this.$store.state.loader = true;
              this.logout();
            }
          });
        }
      } else {
        this.$swal({
          title: this.$t("app.t.text80"),
          text: this.$t("app.t.text81"),
          icon: "warning",
          showCancelButton: true,
          cancelButtonColor: "gray",
          confirmButtonColor: "#c00202",
          confirmButtonText: this.$t("app.t.text82"),
          cancelButtonText: this.$t("app.t.text83"),
        }).then((result) => {
          if (result.isConfirmed) {
            this.$store.state.loader = true;
            this.logout();
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap");

.navbar {
  background: white;
  height: 78px;
  border-bottom: 1px solid #eee;
}

/* Título del calendario junto al logo (Channel Manager) */
.cal-navtitle {
  position: absolute;
  left: 190px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 16px;
  z-index: 2;
  font-family: "DM Sans", sans-serif;
}
.cal-navtitle__bar {
  width: 1px;
  height: 38px;
  background: #e9ecf2;
  flex-shrink: 0;
}
.cal-navtitle__tx {
  text-align: left;
}
.cal-navtitle__t {
  font-size: 16px;
  font-weight: 700;
  color: #1f2733;
  line-height: 1.2;
  letter-spacing: -0.01em;
  text-align: left;
}
/* El hueco del nombre mientras llega. Mismo alto que el título de verdad, para
   que al aparecer no salte nada de sitio. */
.cal-navtitle__hueco {
  width: 168px;
  height: 19px;
  border-radius: 6px;
  background: linear-gradient(90deg, #eef0f4 25%, #f6f7f9 37%, #eef0f4 63%);
  background-size: 400% 100%;
  animation: cal-navtitle-brillo 1.3s ease-in-out infinite;
}
@keyframes cal-navtitle-brillo {
  0%   { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}
@media (prefers-reduced-motion: reduce) {
  .cal-navtitle__hueco { animation: none; }
}

.cal-navtitle__s {
  font-size: 12.5px;
  color: #9ca3af;
  line-height: 1.2;
  margin-top: 3px;
  text-align: left;
}
@media (max-width: 991px) {
  .cal-navtitle { display: none; }
}

/* Botón "Guías y ayuda" en la cabecera del calendario (junto a la campana).
   Aquí el FAB de abajo se oculta para no chocar con las barras de reservas,
   así que este es el acceso al Centro de guías en estas vistas. */
.nav-guides-btn {
  position: relative;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-right: 14px;
  border: 1px solid #e9ebf1;
  background: #f4f4f8;
  color: #673de6;
  cursor: pointer;
  vertical-align: middle;
  transition: background 0.2s cubic-bezier(0.23, 1, 0.32, 1),
    transform 0.2s cubic-bezier(0.23, 1, 0.32, 1),
    box-shadow 0.2s cubic-bezier(0.23, 1, 0.32, 1);
}
.nav-guides-btn:hover {
  background: #efeafe;
  transform: translateY(-1px);
  box-shadow: 0 8px 18px -6px rgba(18, 15, 30, 0.22);
}
.nav-guides-btn:active {
  transform: translateY(0) scale(0.94);
}
.nav-guides-btn__ico {
  display: flex;
}
.nav-guides-btn__ico svg {
  width: 22px;
  height: 22px;
  display: block;
  filter: drop-shadow(0 2px 4px rgba(18, 15, 30, 0.28));
  transition: transform 0.2s cubic-bezier(0.23, 1, 0.32, 1);
}
.nav-guides-btn:hover .nav-guides-btn__ico svg {
  transform: scale(1.07);
}
.nav-guides-btn__dot {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #22c55e;
  border: 2px solid #fff;
  box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55);
  animation: navGuidesLive 2.4s cubic-bezier(0.23, 1, 0.32, 1) infinite;
}
@keyframes navGuidesLive {
  0% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.5); }
  70% { box-shadow: 0 0 0 6px rgba(34, 197, 94, 0); }
  100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
}
.nav-guides-btn__tip {
  position: absolute;
  top: calc(100% + 9px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  background: #14121c;
  color: #fff;
  font-family: "DM Sans", sans-serif;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: -0.1px;
  white-space: nowrap;
  padding: 5px 10px;
  border-radius: 8px;
  pointer-events: none;
  opacity: 0;
  z-index: 30;
  transition: opacity 0.16s ease, transform 0.18s cubic-bezier(0.23, 1, 0.32, 1);
}
.nav-guides-btn__tip::before {
  content: "";
  position: absolute;
  top: -3px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 8px;
  height: 8px;
  background: #14121c;
  border-radius: 2px;
}
.nav-guides-btn:hover .nav-guides-btn__tip {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}
@media (prefers-reduced-motion: reduce) {
  .nav-guides-btn__dot { animation: none; }
}
</style>
